import styled from 'styled-components';

const ModalForm = styled.div`
  position: absolute;
  top: 40%;
  left: calc(50% - 300px);
  width: 600px;
  background-color: #fff;
  padding: 50px;
  border-radius: 20px 20px 20px 0px;
`;

const ModalTitle = styled.div`
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  color: ${(p) => p.theme.colors.gray500};
  margin-bottom: 15px;
  text-align: center;
`;

export {
  ModalForm,
  ModalTitle,
};
